/* bold-notte-negozio — LA NOTTE DA FRANK su reparti, ricerca e schede.
   Il layout lo carica solo dal 24/10 00:00 al 31/10 23:59 ora di Roma.
     1. se la pagina arriva dalla cache dopo il 31, toglie tutto quel che è notte;
     2. il bottone «Copia» (delegato: la griglia la riscrivono i filtri e il
        prezzo della scheda lo riscrive Dawn quando cambi taglia);
     3. il conto breve (7g 06h 12m);
     4. la torcia sulla testata del reparto.
   Niente librerie. */
(function () {
  'use strict';
  if (window.__notteNegozio) return;
  window.__notteNegozio = true;

  var INIZIO = 1792792800000; /* 2026-10-24 00:00 Europe/Rome */
  var FINE = 1793487600000;   /* 2026-11-01 00:00 Europe/Rome */
  var pigro = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function tutti(sel, radice) { return Array.prototype.slice.call((radice || document).querySelectorAll(sel)); }
  function due(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- 1. fuori dalla finestra ---------- */
  function spegni() {
    tutti('.notte-negozio').forEach(function (el) { el.parentNode && el.parentNode.removeChild(el); });
    tutti('.col-testa--notte').forEach(function (t) { t.classList.remove('col-testa--notte'); });
    document.documentElement.classList.add('notte-finita');
  }
  var ora = Date.now();
  if (ora < INIZIO || ora >= FINE) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', spegni); else spegni();
    return;
  }

  /* ---------- 2. copia il codice ---------- */
  function copia(codice) {
    /* gli appunti moderni prima; se il browser dice di no, il vecchio modo */
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(codice).catch(function () { return aMano(codice); });
    }
    return aMano(codice);
  }
  function aMano(codice) {
    return new Promise(function (ok, no) {
      var campo = document.createElement('textarea');
      campo.value = codice;
      campo.setAttribute('readonly', '');
      campo.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
      document.body.appendChild(campo);
      campo.select();
      var fatto = false;
      try { fatto = document.execCommand('copy'); } catch (e) { fatto = false; }
      document.body.removeChild(campo);
      if (fatto) ok(); else no();
    });
  }
  document.addEventListener('click', function (e) {
    var bottone = e.target.closest && e.target.closest('[data-nt-copia]');
    if (!bottone) return;
    var codice = bottone.getAttribute('data-nt-copia');
    var testo = bottone.querySelector('[data-nt-copia-testo]');
    var esito = bottone.parentNode && bottone.parentNode.querySelector('[data-nt-esito]');
    if (!bottone.__originale) bottone.__originale = testo ? testo.textContent : '';
    function dici(riuscito) {
      if (testo) testo.textContent = riuscito ? 'Copiato' : codice;
      if (esito) esito.textContent = riuscito ? codice + ' copiato: incollalo in cassa.' : 'Non riesco a copiarlo: scrivi ' + codice + ' in cassa.';
      bottone.classList.toggle('is-fatto', riuscito);
      window.clearTimeout(bottone.__attesa);
      bottone.__attesa = window.setTimeout(function () {
        if (testo) testo.textContent = bottone.__originale;
        bottone.classList.remove('is-fatto');
      }, 2400);
    }
    copia(codice).then(function () { dici(true); }, function () { dici(false); });
  });

  /* ---------- 3. il conto breve ---------- */
  function batti() {
    var resto = Math.max(0, Math.floor((FINE - Date.now()) / 1000));
    var testo = Math.floor(resto / 86400) + 'g ' + due(Math.floor((resto % 86400) / 3600)) + 'h ' + due(Math.floor((resto % 3600) / 60)) + 'm';
    tutti('[data-nt-breve-testo]').forEach(function (el) { if (el.textContent !== testo) el.textContent = testo; });
    if (resto <= 0) { spegni(); return; }
    window.setTimeout(batti, 20000);
  }

  /* ---------- 4. la torcia sulla testata ---------- */
  function torcia(testa) {
    var luce = testa.querySelector('[data-nt-luce]');
    if (!luce || pigro) return;
    var mouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var pos = { x: 0, y: 0 }, meta = { x: 0, y: 0 }, mano = false, giro = null, visibile = true, t0 = 0;
    function misura() {
      var r = Math.round(Math.min(560, Math.max(300, testa.offsetWidth * (mouse ? 0.34 : 0.9))));
      testa.style.setProperty('--nt-r', r + 'px');
    }
    misura();
    pos.x = testa.offsetWidth * 0.72; pos.y = testa.offsetHeight * 0.6;
    window.addEventListener('resize', misura, { passive: true });
    if (mouse) {
      testa.addEventListener('mousemove', function (e) {
        var b = testa.getBoundingClientRect();
        meta.x = e.clientX - b.left; meta.y = e.clientY - b.top; mano = true;
      });
      testa.addEventListener('mouseleave', function () { mano = false; });
    }
    function frame(t) {
      giro = null;
      if (!visibile || document.hidden) return;
      if (!t0) t0 = t;
      var u = (t - t0) / 1000, w = testa.offsetWidth, h = testa.offsetHeight;
      if (!mano) {
        meta.x = w * (0.62 + 0.26 * Math.sin(u * 0.3));
        meta.y = h * (0.55 + 0.25 * Math.sin(u * 0.47 + 1.1));
      }
      var k = mano ? 0.14 : 0.04;
      pos.x += (meta.x - pos.x) * k;
      pos.y += (meta.y - pos.y) * k;
      var fiamma = 1 + 0.025 * Math.sin(u * 11.3) + 0.015 * Math.sin(u * 23.7 + 0.6);
      luce.style.transform = 'translate3d(' + pos.x.toFixed(1) + 'px,' + pos.y.toFixed(1) + 'px,0) scale(' + fiamma.toFixed(3) + ')';
      giro = window.requestAnimationFrame(frame);
    }
    function avvia() { if (!giro && visibile && !document.hidden) giro = window.requestAnimationFrame(frame); }
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (v) { visibile = v[0].isIntersecting; avvia(); }).observe(testa);
    }
    document.addEventListener('visibilitychange', avvia);
    avvia();
  }

  function parti() {
    batti();
    tutti('[data-nt-testa]').forEach(torcia);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', parti); else parti();
})();
